import { createAction } from 'redux-actions';

export const SET_LISTING_DATA_INFLIGHT = 'LIST.SET_LISTING_DATA_INFLIGHT';
export const setListingDataInFlight = createAction(SET_LISTING_DATA_INFLIGHT);

export const SERVER_RETURNED_LISTING_DATA = 'LIST.SERVER_RETURNED_LISTING_DATA';
export const serverReturnedListingData = createAction(
  SERVER_RETURNED_LISTING_DATA
);

export const GET_ALL_LISTING_DATA = 'LIST.GET_ALL_LISTING_DATA';
export const getAllListingData = createAction(GET_ALL_LISTING_DATA);
